import { render, staticRenderFns } from "./orderPage.vue?vue&type=template&id=44c7d076&scoped=true"
import script from "./orderPage.vue?vue&type=script&lang=js"
export * from "./orderPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c7d076",
  null
  
)

export default component.exports